import React from 'react';

import type { TransactionType } from 'types/api/transaction';

import type { BadgeProps } from 'toolkit/chakra/badge';
import { Badge } from 'toolkit/chakra/badge';

export interface Props {
  types: Array<TransactionType>;
  isLoading?: boolean;
}

const TYPES_ORDER: Array<TransactionType> = [
  'blob_transaction',
  'rootstock_remasc',
  'rootstock_bridge',
  'token_creation',
  'contract_creation',
  'token_transfer',
  'contract_call',
  'coin_transfer',
];

const TxType = ({ types, isLoading }: Props) => {
  const typeToShow = types.sort((t1, t2) => TYPES_ORDER.indexOf(t1) - TYPES_ORDER.indexOf(t2))[0];

  let label;
  let colorScheme: BadgeProps['colorScheme'];

  switch (typeToShow) {
    case 'contract_call':
      label = 'Contract call';
      colorScheme = 'blue';
      break;
    case 'blob_transaction':
      label = 'Blob txn';
      colorScheme = 'orange';
      break;
    case 'contract_creation':
      label = 'Contract creation';
      colorScheme = 'blue';
      break;
    case 'token_transfer':
      label = 'Token transfer';
      colorScheme = 'green';
      break;
    case 'token_creation':
      label = 'Token creation';
      colorScheme = 'green';
      break;
    case 'coin_transfer':
      label = 'Coin transfer';
      colorScheme = 'green';
      break;
    case 'rootstock_remasc':
      label = 'REMASC';
      colorScheme = 'teal';
      break;
    case 'rootstock_bridge':
      label = 'Bridge';
      colorScheme = 'teal';
      break;
    default:
      label = 'Transaction';
      colorScheme = 'gray';
  }

  if (!label) {
    return null;
  }

  return (
    <Badge colorScheme={ colorScheme } loading={ isLoading }>
      { label }
    </Badge>
  );
};

export default TxType;
